import containerFuild from '../html-snippets/container-fuild';
import cssSnippet from '../css-snippets/section-card-slider-yuri';
const html = `
<div>
  <div class="container">
    <div class="wrap-card">
      <div data-show="true" data-attribute="title-card" class="card-title">
        <h2 style="text-align:center;"><span style="color:#e6e6e6;">Why </span><span style="color:#e6e6e6;"><i>It
              Works</i></span></h2>
      </div>
      <div class="wrap-slider">
        <div class="swiper">
          <div data-col-per-view="3" data-attribute="list-item" class="swiper-wrapper">
            <div data-attribute="item" class="swiper-slide">
              <div class="wrap-item">
                <div class="wrap-img">
                  <img data-attribute="image-item"
                    src="https://cdn.skyfastimg.com/images/2026/05/06/image-69fae22dd688db6ac37a5cd5.webp" alt="">
                </div>
                <div data-attribute="content-item" class="wrap-content">
                  <h3>Lorem ipsum dolor sit amet consectetur </h3>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
                </div>
              </div>
            </div>
            <div data-attribute="item" class="swiper-slide">
              <div class="wrap-item">
                <div class="wrap-img">
                  <img data-attribute="image-item"
                    src="https://cdn.skyfastimg.com/images/2026/05/06/image-69fae23a23eb955c76a8e4f6.webp" alt="">
                </div>
                <div data-attribute="content-item" class="wrap-content">
                  <h3>Lorem ipsum dolor sit amet consectetur </h3>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
                </div>
              </div>
            </div>
            <div data-attribute="item" class="swiper-slide">
              <div class="wrap-item">
                <div class="wrap-img">
                  <img data-attribute="image-item"
                    src="https://cdn.skyfastimg.com/images/2026/05/06/image-69fae1bfa0dcd8e9ae309336.webp" alt="">
                </div>
                <div data-attribute="content-item" class="wrap-content">
                  <h3>Lorem ipsum dolor sit amet consectetur </h3>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
  <div data-show="true" data-attribute="decor-bottom" data-color="#ffffff" class="decor-bottom"
    style="--color-decor: #ffffff; display: block;">
    <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
      <path d="M0,60 Q300,120 600,60 T1200,60 V120 H0 Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
`;
export default containerFuild(html, cssSnippet, {
  bottomPadding: false,
  backgroundColor: '#d23a70',
});
